import { render, staticRenderFns } from "./payment-type-spendingcards.vue?vue&type=template&id=62e74534&scoped=true"
import script from "./payment-type-spendingcards.vue?vue&type=script&lang=js"
export * from "./payment-type-spendingcards.vue?vue&type=script&lang=js"
import style0 from "./payment-type-spendingcards.vue?vue&type=style&index=0&id=62e74534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e74534",
  null
  
)

export default component.exports